import React, { useContext } from 'react';
import Heading from '@legacy-vfuk/core-heading';
import Block from '@legacy-vfuk/core-block';
import LinkWithIcon from '@legacy-vfuk/core-link-with-icon';
import RichTextElement from '../../Elements/RichText';
import { SectionDigitalExpertsProps } from './types/SectionDigitalExperts.types';
import DigitalExpert from '../../Elements/DigitalExpert/DigitalExpert';
import {
  BlockWrapper,
  DescriptionWrapper,
  ExpertCardsWrapper,
  HeadingWrapper,
  LinkWithIconWrapper,
  whiteCSS,
  galleryCSS,
} from './styles/SectionDigitalExperts.styles';
import { navigate } from 'gatsby';
import { DirectionContext } from '../../../../contexts/DirectionContext';
import fireButtonAndLinkClicksEvent from '../../../../helpers/fireButtonAndLinkClicksEvent';

const SectionDigitalExperts = ({
  title,
  description,
  experts,
  linkText,
  targetUrl,
  backgroundColor,
}: SectionDigitalExpertsProps) => {
  const direction = useContext(DirectionContext);
  const backgroundCss = backgroundColor === 'white' ? whiteCSS : galleryCSS;

  const onClick = () => {
    fireButtonAndLinkClicksEvent({
      event_label: linkText,
      event_action: 'link click',
    });
    navigate(targetUrl);
  };

  return (
    <BlockWrapper>
      <Block css={backgroundCss}>
        <HeadingWrapper>
          <Heading text={title} level={3} justify="center" />
        </HeadingWrapper>
        <DescriptionWrapper>
          <RichTextElement
            key={description.id}
            text={description.text}
            color={description.color}
            textAlign={description.textAlign}
          />
        </DescriptionWrapper>
        <ExpertCardsWrapper>
          {experts.map(expert => {
            return (
              <DigitalExpert
                avatarImage={expert.avatarImage}
                expertName={expert.expertName}
                expertSummary={expert.expertSummary}
              />
            );
          })}
        </ExpertCardsWrapper>
        {linkText && (
          <LinkWithIconWrapper isRtl={direction === 'rtl'}>
            <LinkWithIcon
              appearance="primary"
              text={linkText}
              icon={{
                name: 'chevron-right',
                justify: 'right',
              }}
              onClick={() => onClick()}
            />
          </LinkWithIconWrapper>
        )}
      </Block>
    </BlockWrapper>
  );
};

export default SectionDigitalExperts;
